import { useState } from 'react';
import { motion } from 'framer-motion';
import { Instagram, Lock, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const ComingSoonPage = ({ onAuthenticate }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPasswordInput, setShowPasswordInput] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simple password check - change this password as needed
    if (password === 'tezr2025') {
      localStorage.setItem('tezr_authenticated', 'true');
      onAuthenticate();
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };

  return (
    <div className="min-h-screen bg-stone-50 flex flex-col">
      {/* Background Images */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 grid grid-cols-3 opacity-10">
          <div className="h-full">
            <img
              src="/images/TEASER HERO.jpg"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="h-full">
            <img
              src="/images/REFORMER HERO.jpg"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="h-full">
            <img
              src="/images/LADDER BARREL HERO 1.jpg"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-stone-50/80 via-stone-50/90 to-stone-50" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-2xl mx-auto"
        >
          {/* Logo */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-8"
          >
            <img
              src="/images/TEZR LOGO.png"
              alt="TEZR Pilates"
              className="h-20 md:h-28 mx-auto"
            />
          </motion.div>

          {/* Otto Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            className="mb-10 mx-auto w-64 h-80 md:w-72 md:h-96 overflow-hidden"
          >
            <img
              src="/images/otto.jpeg"
              alt="Otto Prodan"
              className="w-full h-full object-cover"
            />
          </motion.div>

          {/* Coming Soon */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="font-heading text-5xl sm:text-6xl lg:text-7xl text-stone-900 leading-[1.1] tracking-tight mb-6"
          >
            Coming <span className="italic">Soon</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            className="text-stone-600 text-lg md:text-xl leading-relaxed font-light mb-10"
          >
            Classical. Contemporary. Complete.
          </motion.p>

          {/* Instagram Link */}
          <motion.a
            href="https://www.instagram.com/tezrpilates"
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
            className="inline-flex items-center gap-3 px-8 py-4 bg-stone-900 text-white hover:bg-stone-800 transition-colors"
          >
            <Instagram size={20} strokeWidth={1.5} />
            <span className="text-sm uppercase tracking-widest font-medium">Follow on Instagram</span>
          </motion.a>

          {/* Admin Access */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
            className="mt-16"
          >
            {!showPasswordInput ? (
              <button
                onClick={() => setShowPasswordInput(true)}
                className="inline-flex items-center gap-2 text-stone-400 hover:text-stone-600 transition-colors text-sm"
              >
                <Lock size={14} strokeWidth={1.5} />
                <span>Admin Access</span>
              </button>
            ) : (
              <form onSubmit={handleSubmit} className="max-w-xs mx-auto">
                <div className="flex gap-2">
                  <Input
                    type="password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setError('');
                    }}
                    placeholder="Enter password"
                    className="bg-white border-stone-200 text-stone-900 placeholder:text-stone-400"
                    autoFocus
                  />
                  <Button
                    type="submit"
                    className="bg-stone-900 hover:bg-stone-800 text-white px-4"
                  >
                    <ArrowRight size={18} strokeWidth={1.5} />
                  </Button>
                </div>
                {error && (
                  <p className="text-red-500 text-sm mt-2">{error}</p>
                )}
              </form>
            )}
          </motion.div>
        </motion.div>
      </div>

      {/* Footer */}
      <div className="relative z-10 py-8 text-center">
        <p className="text-stone-400 text-xs font-light">
          © {new Date().getFullYear()} TEZR Pilates. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default ComingSoonPage;
